// extracted by mini-css-extract-plugin
export var addressFields = "_hs-0";
export var animationContainer = "_hs-1";
export var footer = "_hs-2";
export var lineItems = "_hs-3";
export var modalContent = "_hs-4";
export var orderName = "_hs-5";
export var strong = "_hs-6";
export var warning = "_hs-7";